import React, { useEffect, useState } from "react";
import PayloftLogo from "../assets/images/payloft-logo.png";
import { passwordChange, passwordReset } from "../services/onboarding";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const PasswordReset = () => {
  const [newPassword, setNewPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [inputPassNew, setInputPassNew] = useState("password");
  const [showNew, setShowNew] = useState(false);
  const [inputPassConfirm, setInputPassConfirm] = useState("password");
  const [showConfirm, setShowConfirm] = useState(false);

  const handleShowNew = () => {
    setShowNew(!showNew);
    setInputPassNew(inputPassNew === "password" ? "text" : "password");
  };

  const handleShowConfirm = () => {
    setShowConfirm(!showConfirm);
    setInputPassConfirm(inputPassConfirm === "password" ? "text" : "password");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      setLoading(false);
      return;
    }
    try {
      const response = await passwordReset({
        Token: token,
        NewPassword: newPassword,
        EmailAddress: email,
      });
      toast.success(response.message);
      navigate("/");
    } catch (error) {
      if (error.response) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    }
  };

  const safeAtob = (str) => {
    try {
      return str ? atob(str) : "";
    } catch (e) {
      return str || "";
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const emailParam = urlParams.get("emailAddress");
    const tokenParam = urlParams.get("token");

    const decodedEmail = safeAtob(emailParam);
    const decodedToken = safeAtob(tokenParam);

    setToken(decodedToken);
    setEmail(decodedEmail);
  }, []);

  console.log("token:", token);
  console.log("email:", email);

  return (
    <div className="flex justify-center">
      <div className="md:w-[448px] max-w-96 p-4">
        <div className="flex items-center justify-center">
          <img
            src={window.__TENANT__?.logo ?? PayloftLogo}
            alt="logo"
            className="w-[92px] h-[92px]"
          />
        </div>
        <h1 className="text-[25px] font-semibold border-b pb-20 text-center mt-20">
          Reset Password
        </h1>
        <div className="flex flex-col">
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col mt-6 relative">
              <label htmlFor="new-password">New Password</label>
              <input
                onChange={(e) => setNewPassword(e.target.value)}
                type={inputPassNew}
                id="new-password"
                placeholder="......."
                className="focus:outline-none h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
              />
              <button
                className="absolute right-4 top-14"
                onClick={handleShowNew}
              >
                {showNew ? <FaEyeSlash /> : <FaEye />}{" "}
              </button>
            </div>
            <div className="flex flex-col mt-4 relative">
              <label htmlFor="confirm-password">Confirm Password</label>
              {/* <svg
                                className="absolute right-4 top-14"
                                width="13"
                                height="11"
                                viewBox="0 0 13 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g opacity="0.5">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M5.07225 7.60439C5.47815 7.87832 5.97285 8.04395 6.49926 8.04395C7.89456 8.04395 9.02983 6.90365 9.02983 5.50218C9.02983 4.97344 8.86493 4.47655 8.59221 4.06885L7.9009 4.76322C8.01506 4.97981 8.07848 5.23462 8.07848 5.50218C8.07848 6.37491 7.36815 7.08839 6.49926 7.08839C6.23288 7.08839 5.97919 7.02469 5.76355 6.91002L5.07225 7.60439ZM10.6787 1.97322C11.5984 2.8141 12.3785 3.94802 12.962 5.31128C13.0127 5.43232 13.0127 5.57246 12.962 5.68713C11.6047 8.85956 9.18829 10.7579 6.49917 10.7579H6.49283C5.26877 10.7579 4.09545 10.3566 3.06165 9.62401L1.83125 10.8599C1.73612 10.9554 1.61562 11 1.49511 11C1.37461 11 1.24776 10.9554 1.15897 10.8599C1.00041 10.7006 0.975045 10.4458 1.10189 10.261L1.12092 10.2356L10.5011 0.813812L10.5012 0.813807C10.5138 0.801068 10.5265 0.788329 10.5329 0.77559L10.5329 0.775584C10.5455 0.762845 10.5582 0.750107 10.5646 0.737368L11.1607 0.138555C11.351 -0.046185 11.6491 -0.046185 11.833 0.138555C12.0233 0.323295 12.0233 0.629072 11.833 0.813812L10.6787 1.97322ZM3.96392 5.50482C3.96392 5.67045 3.98295 5.83608 4.00832 5.98897L1.66168 8.34599C1.02745 7.60703 0.475671 6.71519 0.0380537 5.68956C-0.0126846 5.57489 -0.0126846 5.43475 0.0380537 5.31371C1.3953 2.14128 3.81171 0.249282 6.49449 0.249282H6.50083C7.40778 0.249282 8.28936 0.465874 9.10117 0.873576L6.98285 3.00127C6.83063 2.97579 6.66573 2.95668 6.50083 2.95668C5.09919 2.95668 3.96392 4.09697 3.96392 5.50482Z"
                                        fill="#030229"
                                    />
                                </g>
                            </svg> */}
              <input
                onChange={(e) => setConfirmPassword(e.target.value)}
                type={inputPassConfirm}
                id="confirm-password"
                placeholder="....."
                className="focus:outline-none h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
              />
              <button
                className="absolute right-4 top-14"
                onClick={handleShowConfirm}
              >
                {showConfirm ? <FaEyeSlash /> : <FaEye />}{" "}
              </button>
            </div>
            <div className="mt-4">
              <p className="font-normal text-[13px] text-gray-400">
                Characteristics of strong passwords
              </p>
              <p className="text-[13px] font-normal mt-4">
                At least 8 characters-the more characters, the better.
              </p>
              <p className="text-[13px] font-normal">
                A mixture of both uppercase and lower letters.
              </p>
              <p className="text-[13px] font-normal">
                A mixture of letters and numbers.
              </p>
              <p className="text-[13px] font-normal">
                Inclusion of at least one special character e.g. !@#?&#93;
              </p>
              <p className="text-gray-400 text-[13px] font-normal mt-6 w-[348px]">
                {" "}
                Note: do not use &lt; or &gt; in your password, as both can
                cause problems in Web browsers.
              </p>
            </div>
            <div className="mt-8">
              <button
                type="submit"
                className="bg-primary text-white w-[22rem] md:w-[400px] h-[50px] rounded-md"
              >
                Confirm Password Reset
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
